import { Plugin } from 'prosemirror-state';

import { BaseExtension, EditorOptions, extensionType } from '@lyearn/lygo-core';

import { insertNode, removeMenuContainer, selectionType, setSelection } from '../../utils';

const NEW_LINE_CONTAINER_ID = 'new-line-container';

export default class NewLine extends BaseExtension {
  get type(): string {
    return extensionType.toolbar;
  }

  get name(): string {
    return 'new_line';
  }

  plugins(_editorOptions: EditorOptions) {
    return [
      new Plugin({
        view: (view) => {
          // This will be called only once.
          // It will add a container div after the ProseMirror Content DOM.
          let newLineContainer = document.createElement('div');
          newLineContainer.id = NEW_LINE_CONTAINER_ID;
          newLineContainer.className = 'w-full h-128';
          const addNewLineOnClick = () => {
            // @ts-ignore
            if (!view.docView || _editorOptions.isMicroLearning) {
              return;
            }
            const nodes = view.state.schema.nodes;
            // @ts-ignore
            const domNode = view.domAtPos(view.docView.posAtEnd - 1);
            if (
              (domNode.node && domNode.node.nodeName !== 'P') ||
              (domNode.node.nodeName === 'P' && domNode.node.textContent !== '') ||
              //@ts-ignore
              (domNode.node.nodeName === 'P' && domNode.node.classList.contains('callout'))
            ) {
              insertNode(
                view,
                selectionType.NODE,
                nodes.paragraph.create(),
                // @ts-ignore
                view.docView.posAtEnd,
              );
            }
            view.focus();
            // @ts-ignore
            setSelection(view, selectionType.TEXT, view.docView.posAtEnd - 1);
          };
          newLineContainer.addEventListener('click', addNewLineOnClick);
          view?.dom?.parentNode?.appendChild(newLineContainer);

          // Need to return the following functions in the view function
          return {
            update: () => {},
            destroy: () => {
              removeMenuContainer(NEW_LINE_CONTAINER_ID, view);
            },
          };
        },
      }),
    ];
  }
}
